import { render, staticRenderFns } from "./p295_shipping_service.vue?vue&type=template&id=0f4e6f8a"
import script from "./p295_shipping_service.vue?vue&type=script&lang=js"
export * from "./p295_shipping_service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Radio: require('/root/containers/hermes_eshop/components/hyper/p295/radio.vue').default,Panel: require('/root/containers/hermes_eshop/components/hyper/p295/panel.vue').default})
